import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface PaymentDetail {
  id: string;
  amount: string;
  paymentTypeName: string;
  sourceName: string;
  calculationDetails?: string;
}

interface PaymentCheckDetailsProps {
  check: {
    id: string;
    payeeName: string;
    payeeType: string;
    checkNumber: number;
    totalAmount: string;
    status: string;
    issueDate?: string | null;
    paymentDetails?: PaymentDetail[];
  };
  onClose: () => void;
}

const PaymentCheckDetails: React.FC<PaymentCheckDetailsProps> = ({
  check,
  onClose,
}) => {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Check #{check.checkNumber} Details</DialogTitle>
          <DialogDescription>
            Detailed information for this payment check
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <div>
            <span className="font-medium">Payee:</span> <b>{check.payeeName}</b>{" "}
            ({check.payeeType})
          </div>
          <div>
            <span className="font-medium">Total Amount:</span>{" "}
            <b>${check.totalAmount}</b>
          </div>
          <div>
            <span className="font-medium">Status:</span> <b>{check.status}</b>
          </div>
          <div>
            <span className="font-medium">Issue Date:</span>{" "}
            <b>
              {check.issueDate
                ? new Date(check.issueDate).toLocaleDateString()
                : "-"}
            </b>
          </div>
        </div>
        <h3 className="font-semibold mt-4 mb-2 text-base">Payment Details</h3>
        <ul>
          {(check.paymentDetails ?? []).map((detail) => (
            <li key={detail.id} className="mb-1">
              <b>{detail.paymentTypeName}</b> - {detail.sourceName}: $
              {detail.amount}
              {detail.calculationDetails && (
                <span className="ml-2 text-muted-foreground">
                  ({detail.calculationDetails})
                </span>
              )}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentCheckDetails;
